// public/js/pages/assets.js (fully replaced)
import { initAssetsPage as initAssetsOrchestrator } from '../features/assets/assets-page.js';

export async function initAssetsPage(container) {
  await initAssetsOrchestrator(container);
}